import React from "react";
import heroimg from "./../../static/img/skillset.png";

const HeroBlog = class extends React.Component {
  render() {
    return (
      <div
        style={{
          background: "linear-gradient(to bottom right,#80159F, #8061FF)",
          padding:20
        }}
      >
        <section class="hero  ">
          <div class="hero-body">
          <div style={{color:'#fff'}}>
                <p style={{fontFamily:'Honey',fontSize:32,textAlign:'center'}}>"The first step is you have to say that you can."<br/> - Will Smith</p>
     
              </div>
          </div>
        </section>
      </div>
    );
  }
};

export default HeroBlog;
